import React, { Component } from 'react'
import image from '../../mouseimages/dpi.jpg'
import '../stylesheets/Dpi.css'
export default class Dpi extends Component {
    render() {
        return (
            <div className="dpi-container" data-aos="fade-right">
            <img src={image} alt="dpi"></img>
           </div>
        )
    }
}
